import { useNavigate, useLocation } from "react-router-dom";
import Icon from "@/components/Icon";
import { useSbAuth } from "@/context/SupabaseAuthContext";

// Mobile "Golv-läge" (Floor Mode) — fixed bottom bar with large 56px touch
// targets so stressed staff can navigate with a thumb during service.
// Only rendered on small screens (md:hidden).
export function FloorBar() {
  const { hasPermission } = useSbAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const items = [
    { key: "", label: "Hem", icon: "LayoutDashboard" },
    { key: "live", label: "Live", icon: "MonitorPlay" },
    { key: "operation", label: "Operation", icon: "LayoutGrid" },
  ];
  if (hasPermission("dashboard.access")) items.push({ key: "ledning", label: "Ledning", icon: "PieChart" });
  else if (hasPermission("foodcost.access")) items.push({ key: "foodcost", label: "Ekonomi", icon: "BarChart3" });

  const seg = loc.pathname.replace(/^\/konto\/?/, "").split("/")[0];
  const activeKey = items.some((n) => n.key === seg) ? seg : "";

  return (
    <nav
      data-testid="floor-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-card/95 backdrop-blur-md border-t border-border"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid" style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}>
        {items.map((it) => {
          const active = it.key === activeKey;
          return (
            <button
              key={it.key || "home"}
              data-testid={`floor-nav-${it.key || "home"}`}
              onClick={() => nav(it.key ? `/konto/${it.key}` : "/konto")}
              className={`flex flex-col items-center justify-center gap-1 min-h-[56px] py-2 transition-colors active:scale-95 ${
                active ? "text-primary" : "text-muted-foreground"
              }`}
            >
              <Icon name={it.icon} className="h-6 w-6" strokeWidth={active ? 2.2 : 1.8} />
              <span className={`text-[11px] leading-none ${active ? "font-semibold" : "font-medium"}`}>{it.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
